<template>
  <div class="wrap">
    <h3>{{ fairConfig.FC_MODERATORSMSG_TITLE }}</h3>
    <p>
      {{ fairConfig.FC_MODERATORSMSG }}
    </p>
    <div class="button-wrap">
      <div class="button-round" @click="$emit('next-success')">
        {{ $t('button.next') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    date: String,
  },
  computed: {
    ...mapState(['fairConfig']),
  },
}
</script>

<style scoped lang="scss">
.wrap {
  text-align: center;
}
.button-wrap {
  display: flex;
  justify-content: flex-end;
}
.button-round {
  background: var(--button-color-yellow);
}
</style>
